<dialog-report-problem (formSubmit)="submit($event)" [isResultState]="isResultState()" [isErrorState]="isErrorState()">
  <div id="fields-top">
    <div class="dialog-option-available__item-right dialog-option-available__item-right--flex">
      <div>
        <label for="issueType" class="form-label">{{ "Domains.ReportIssue.SelectIssueType" | translate }}</label>
        <div class="select-wrapper">
          <select [(ngModel)]="issueType" class="select" id="issueType" name="issueType">
            @for (type of ISSUE_TYPES; track type.value) {
              <option [value]="type.value" [selected]="issueTypeIs(type.value)">
                {{ type.labelKey | translate }}
              </option>
            }
          </select>
          <svg-icon src="assets/images/icons/select-arrows.svg"></svg-icon>
        </div>
      </div>
      <div style="flex-grow: 1">
        <div class="input__wrapper">
          <label for="specificObject" class="form-label">{{ "Domains.ReportIssue.SpecificObject" | translate }}</label>
          <input [(ngModel)]="specificObject" class="input" id="specificObject" type="text" name="specificObject" />
        </div>
      </div>
    </div>
  </div>
</dialog-report-problem>
